module.exports = __webpack_public_path__ + "img/logo-color-adaptive.d4c037d0.svg";